module.exports = __webpack_public_path__ + "img/challenges.c1a588de.png";